import EditionsFacet from "../UI/EditionFacet";
import Facet from "../UI/Facet";
import SearchLoader from "../UI/SearchLoader";
const channelIndex = process.env.REACT_APP_PROJECT_INDEX || undefined;

const FacetsContainer = ({
  facetsList,
  isLoading,
  selections,
  filtersHandler
}) => {
  const facetsToRender = [];
  if (facetsList?.length) {
    facetsList.forEach((facet) => {
      const facetFilter = (id) => {
        if(channelIndex === "syllabus") {
          return id!== "editions" && id !== 'modules'
        } 
        return id !== 'editions'
      }
      // here module check for testing
      if (facetFilter(facet.id)) {
        facetsToRender.push(
          <Facet
            label={facet.label}
            facetValues={facet.values}
            selections={selections}
            id={facet.id}
            filtersHandler={filtersHandler}
            key={facet.id}
          />
        );
      } else if (facet.id === "editions") {
        facetsToRender.push(
          <EditionsFacet
            label={facet.label}
            facetValues={[...facet.values].sort((a,b)=>b.edition-a.edition)}
            selections={selections}
            id={facet.id}
            filtersHandler={filtersHandler}
            key={facet.id}
          />
        );
      } 
    });
  }
  return (
    <div className="w-full flex flex-col items-center">
      {isLoading && <SearchLoader />}
      {!isLoading && facetsToRender.length ? facetsToRender : null}
    </div>
  );
};

export default FacetsContainer;
